<div class="widget">
    <app-dynamic-template #dynamicTemplate *ngIf="w && !w.disableTemplate" [template]="w.html"></app-dynamic-template>
    <div *ngIf="w && w.disableTemplate" class="">
        <div class="card text-decoration-none bg-emphasis bg-opacity-25">
            <div class="card-body align-items-center text m-5px">
                <div *ngIf="data && data.data" [innerHTML]="data.data | safe:'html'"></div>
            </div>
        </div>
    </div>
</div>
